import React from 'react';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { Divider } from '@mui/material';
import type { SubScoresRecords } from './types';
import { Dialog, TextField } from '../../../../../components';

export type SubScoresRecordDialogProps = {
  dialogTitle: string;
  historyRecords: SubScoresRecords[];
  openDialog: boolean;
  cancelAction?: string;
  onDialogClose: () => void;
};

export const SubScoresRecordDialog: React.FC<SubScoresRecordDialogProps> = (
  props: SubScoresRecordDialogProps,
) => {
  const {
    dialogTitle,
    historyRecords = [],
    openDialog,
    cancelAction,
    onDialogClose,
  } = props;

  return (
    <Dialog
      dialogTitle={dialogTitle}
      openDialog={openDialog}
      onDialogClose={onDialogClose}
      displayCloseButton
      cancelAction={cancelAction}
      width={'45rem'}
    >
      <div className="flex flex-col items-center h-[28rem] overflow-auto w-full">
        {historyRecords.map((historyRecord, index) => {
          const historyYear = dayjs(historyRecord.date).year();
          const historyMonth = dayjs(historyRecord.date).format('MMM'); // Get full month name
          const historyDay = dayjs(historyRecord.date).date();
          return (
            <div key={index} className="flex flex-row w-full pl-2 pr-2">
              <div className="flex flex-col items-center mb-3">
                <DateTitle>
                  <h2>{historyDay}</h2>
                  <h3>{historyMonth + ', ' + historyYear}</h3>
                </DateTitle>
                <Divider orientation="vertical" />
              </div>

              <div className="mt-3 ml-2">
                {historyRecord.content.map((record, index) => {
                  const { time, dimensions } = record;
                  const { justification, createdBy } = dimensions?.[0];
                  return (
                    <div key={index} className="mb-4">
                      <div className="font-medium mb-2">
                        {`${time} by ${createdBy}`}
                      </div>
                      <div className="p-4 bg-[#F6F6F6] w-full rounded border-solid shadow">
                        <div className="  grid grid-cols-2 gap-4">
                          {dimensions.map((dimension, index) => {
                            const { dimensionName, snapshot } = dimension;
                            return (
                              <div
                                key={index}
                                className="flex flex-row grid grid-cols-4 items-center"
                              >
                                <span className="col-span-3 text-sm">
                                  {dimensionName}
                                </span>
                                <span className="col-span-1 flex flex-col items-center justify-center text-[#951D1D] text-sm">
                                  {snapshot}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                        <div className="mt-4">
                          <TextField
                            disabled
                            value={justification}
                            fullWidth
                            multiline
                            minRows={2}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </Dialog>
  );
};

const DateTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  min-width: 7rem;
  background-color: #ffffff;

  h2 {
    font-size: 1.5rem;
    font-weight: 700;
    margin: 0;
  }

  h3 {
    font-size: 0.9rem;
    font-weight: 700;
    margin: 0;
  }
`;
